export default "__VITE_ASSET__592cc798__"